import styled, { createGlobalStyle } from 'styled-components';

export const PanelPosition = createGlobalStyle`
  @media (min-width: 30.625em) {
    .Polaris-Modal-Dialog__Container {
      justify-content: flex-start;
      padding-top: 80px;
    }

    /* Cap the panel height so a tall Connection/Config tab still leaves as
       much clearance at the bottom as the fixed 80px anchor leaves at the top,
       instead of overflowing past the viewport and hiding the footer actions. */
    .Polaris-Modal-Dialog__Modal {
      max-height: calc(100vh - 160px);
    }

    .Polaris-Modal-Dialog__Modal > .Polaris-Box:first-child {
      padding-block-end: 0 !important;
    }

    .Polaris-Modal-Dialog__Modal > .Polaris-Box:first-child .Polaris-InlineGrid {
      align-items: flex-start;
    }
  }
`;

export const TitleWrapper = styled.div<{ $hasTabs: boolean }>`
  padding-bottom: ${({ $hasTabs }) => ($hasTabs ? '0' : '16px')};
`;

export const TabList = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 4px;
  margin-top: 12px;
`;

export const TabButton = styled.button<{ $active: boolean }>`
  padding: 8px 16px;
  margin-bottom: -1px;
  cursor: pointer;
  background: none;
  border: none;
  border-bottom: 2px solid ${({ $active }) => ($active ? '#1a1a1a' : 'transparent')};
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  color: ${({ $active }) => ($active ? '#1a1a1a' : '#616161')};

  &:hover {
    border-bottom-color: ${({ $active }) => ($active ? '#1a1a1a' : '#c9cccf')};
  }
`;
